export function setYear(state, payload) {
  state.year = payload;
}

export function setContractCode(state, payload) {
  state.contractCode = payload;
}

export function setProductComponentCodesToIgnore(state, payload) {
  state.productComponentCodesToIgnore = payload;
}

export function setNewlyParticipantCustomerNumbers(state, payload) {
  state.newlyParticipantCustomerNumbers = payload;
}

export function setAgreementId(state, payload) {
  state.agreementId = payload;
}

export function setShowDenialReason(state, payload) {
  state.showDenialReason = payload;
}

export function setDenialReasonData(state, payload) {
  state.denialReasonData = payload;
}

export function setCurrentMedicalSelectionData(state, payload) {
  state.medicalSelectionOverlayData = payload;
}

export function setShowMedicalSelectionOverlay(state, payload) {
  state.showMedicalSelectionOverlay = payload;
}

export function setShowRejected(state, payload) {
  state.showRejected = payload;
}

export function setRejectedData(state, payload) {
  state.rejectedData = payload;
}
